import { useEffect, useState } from "react";
import { Loader2, Bookmark } from "lucide-react";
import api from "@/lib/api";
import { ContentCard } from "@/components/ContentCard";
import { useAuth } from "@/context/AuthContext";

export default function MyList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { favorites } = useAuth();

  useEffect(() => {
    setLoading(true);
    api.get("/me/list").then(({ data }) => setItems(data.items)).finally(() => setLoading(false));
  }, [favorites.length]);

  return (
    <div className="pt-24 px-4 sm:px-8 lg:px-12 pb-20 min-h-screen" data-testid="my-list-page">
      <div className="flex items-center gap-3 mb-6">
        <Bookmark className="text-brand" size={28} />
        <h1 className="font-head text-3xl sm:text-4xl font-extrabold">My List</h1>
      </div>
      {loading ? (
        <div className="grid place-items-center py-20"><Loader2 className="animate-spin text-brand" size={36} /></div>
      ) : items.length === 0 ? (
        <div className="text-center text-zinc-400 py-20">
          <p className="text-lg">Your list is empty.</p>
          <p className="text-sm mt-1">Tap the + on any title to save it here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {items.map((it) => <ContentCard key={it.id} item={it} />)}
        </div>
      )}
    </div>
  );
}
